// extracted by mini-css-extract-plugin
module.exports = {"watchWrapper":"stopwatch_watchWrapper__3gXmj","watchIllust":"stopwatch_watchIllust__2Gd0c","watchInner":"stopwatch_watchInner__10b3l"};